import type { ReactNode } from 'react';
import { Container } from '~/components/ui';
import { cn } from '~/lib/cn';

export function Section({
  className,
  containerClassName,
  children,
}: {
  className?: string;
  containerClassName?: string;
  children: ReactNode;
}) {
  return (
    <section className={cn('py-10 md:py-14', className)}>
      <Container className={containerClassName}>{children}</Container>
    </section>
  );
}

/** Section heading with the full-width divider underneath (Figma pattern). */
export function SectionHeading({ title, className }: { title: string; className?: string }) {
  return (
    <div className={cn('border-b border-black-6 pb-8', className)}>
      <h2 className="max-w-xl text-h3 font-semibold tracking-[-0.03em] text-balance md:text-h2">
        {title}
      </h2>
    </div>
  );
}
